import { useAuth } from './useAuth.js';

interface EntityLabels {
  isReseller: boolean;
  reseller: string;
  resellers: string;
  Reseller: string;
  Resellers: string;
  RESELLER: string;
  RESELLERS: string;
}

export function useEntityLabels(): EntityLabels {
  const { user } = useAuth();
  const isReseller = user?.tenantType === 'reseller';

  return isReseller
    ? {
        isReseller: true,
        reseller: 'customer',
        resellers: 'customers',
        Reseller: 'Customer',
        Resellers: 'Customers',
        RESELLER: 'CUSTOMER',
        RESELLERS: 'CUSTOMERS',
      }
    : {
        isReseller: false,
        reseller: 'reseller',
        resellers: 'resellers',
        Reseller: 'Reseller',
        Resellers: 'Resellers',
        RESELLER: 'RESELLER',
        RESELLERS: 'RESELLERS',
      };
}
